
export const ROUTES = {
    LOGIN: '/',
    NOT_FOUND: '/not-found',
    HOME: "/home",
    WILD_CARD: '*',
    DASHBOARD: '/dashboard',
    CALENDAR: '/calendar',
    KANBAN: '/kanban',
    ANALYTICS: '/analytics',
    TEAM: '/agent',
    DOMAIN_MAPPING: '/domain-mapping',
    YARDS: '/yards',
    MAIL: '/mail-box',
    MYFOLLOWUPS: '/my-follow-ups',
    MYLEADS: '/my-leads',
    REVIEWLEADS: '/review-leads',
    ACCOUNT_SESSIONS: '/account-sessions',
    ErrorLeads: '/error-lead',
    SALEMADE: '/sale-made',
    VIEWYARDPAGE: '/yard-page',
    PrivacyPolicy: '/privacy-policy',
    TEAMS: '/terms-and-conditions',
    ISSUETRACKING: '/issue-tracking',
    PendingPayment:'/pending-payment',
    advancePayment:'/advance-payment',
    orderPending:'/order-pending',
    ShipmentTracking:"/shipment-tracking",
    ShipmentTrackingComplete:"/shipment-tracking-complete",
    orderComplete:'/order-complete',
    Invoice:'/invoice',
    InvoicePending:'/invoice-pending',
    InvoiceCompleted:'/invoice-completed',
    YardRefund:'/yard-refund',
    CustomerRefund:'/customer-refund',
    SaleMadeComplete:'/Sale-made-complete',
    dispute:'/dispute-lead',
    CustomerCancel:'/customer-cancel',
    ReLocate:'re-locate',
        YardRefundCompleted:'/yard-refund-completed',
    CustomerRefundCompleted:'/customer-refund-completed',
    FLOW_DIAGRAM:'/flow-diagram',

}
